<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <button v-on:click="onCreate()" class="btn btn-primary">Create</button>
          </div>           
          <div class="col-md-6">
            <div class="row" style="margin-right:0px;margin-bottom:5px;">
              <div class="col-sm-3 col-md-3">
                <div class="form-inline">
                  <label for="pagesize">Show</label>                    
                  <select id="pagesize" @change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>                   
                </div>
              </div>               
              <div class="col-sm-9 col-md-9 has-feedback">
                <div class="row">
                  <input type="text" class="form-control" v-on:keyup.enter="onSearch($event)" placeholder="Search by company name">
                  <span class="icon ion-search form-control-feedback"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-for="(row, i) in listData" v-bind:key="i">
      <div class="row" v-if="i % 4 === 0">
        <div class="col-md-3 col-sm-6 col-xs-12" v-if="listData[i] != undefined" @click="onDisplay(listData[i])">
          <div class="info-box" style="padding:5px;border-color:#d9d7d7;border:1px solid #d9d7d7">
            <div style="float:left;">
              <img class="attachment-img" :src="'/image/Company/' + listData[i].imageUrl + '?' + Date.now()" alt="Company Image" style="width:64px;">
            </div>
            <div class="info-box-content" style="text-align:left;margin-left:70px;">
              <span class="info-box-text" style="text-transform:none;">{{ listData[i].name }}</span>
              <span class="info-box-number">{{ listData[i].description }}</span>
            </div>             
          </div>         
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12" v-if="listData[i+1] != undefined" @click="onDisplay(listData[i+1])">
          <div class="info-box" style="padding:5px;border-color:#d9d7d7;border:1px solid #d9d7d7">
            <div style="float:left;">
              <img class="attachment-img" :src="'/image/Company/' + listData[i+1].imageUrl + '?' + Date.now()" alt="Company Image" style="width:64px;">
            </div>
            <div class="info-box-content" style="text-align:left;margin-left:70px;">
              <span class="info-box-text" style="text-transform:none;">{{ listData[i+1].name }}</span>
              <span class="info-box-number">{{ listData[i+1].stock }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12" v-if="listData[i+2] != undefined" @click="onDisplay(listData[i+2])">
          <div class="info-box" style="padding:5px;border-color:#d9d7d7;border:1px solid #d9d7d7">
            <div style="float:left;">
              <img class="attachment-img" :src="'/image/Company/' + listData[i+2].imageUrl + '?' + Date.now()" alt="Company Image" style="width:64px;">
            </div>
            <div class="info-box-content" style="text-align:left;margin-left:70px;">
              <span class="info-box-text" style="text-transform:none;">{{ listData[i+2].name }}</span>
              <span class="info-box-number">{{ listData[i+2].stock }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12" v-if="listData[i+3] != undefined" @click="onDisplay(listData[i+3])">
          <div class="info-box" style="padding:5px;border-color:#d9d7d7;border:1px solid #d9d7d7">
            <div style="float:left;">
              <img class="attachment-img" :src="'/image/Company/' + listData[i+3].imageUrl + '?' + Date.now()" alt="Company Image" style="width:64px;">
            </div>
            <div class="info-box-content" style="text-align:left;margin-left:70px;">
              <span class="info-box-text" style="text-transform:none;">{{ listData[i+3].name }}</span>
              <span class="info-box-number">{{ listData[i+3].stock }}</span>
            </div>
          </div>
        </div>
      </div> 
    </div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="row pull-right">
          <div class="form-group">
            <label style="width:25px;text-align:right;">
                <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
            </label>
            <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
            </label>
            <label>
                Page
            </label>
            <label>
                <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
            </label>
            <label id="TotalPageText">
              {{ totalPages }}                
            </label>
            <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
            </label>
            <label style="width:25px;text-align:left;">
                <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
            </label>
          </div>
        </div> 
      </div>
    </div> 
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'

export default {
  name: 'Company',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      viewMode: MODE_NONE,
      listCurrency: null
    }
  },
  computed: {
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      api
        .request('Account', 'get', '/api/Company/Inquiry?WhereClause=' + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCurrency() {
      api
        .request('Account', 'get', '/api/Currency/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreate() {
      let params = {
        id: 0,
        mode: MODE_CREATE,
        callback: this.$route.name
      }
      this.$router.push({ name: 'Company Form', params: params })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'Company Form', params: params })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Company.vue?b5465b8e